import { WaitingLineType } from 'lib/graphql/graphql';

export const silver = {
  waitingLineType: WaitingLineType.Silver,
  title: `waiting_line_${WaitingLineType.Silver}_type`,
  descriptions: [
    `waiting_line_${WaitingLineType.Silver}_description_1`,
    `waiting_line_${WaitingLineType.Silver}_description_2`,
    `waiting_line_${WaitingLineType.Silver}_description_3`,
    `waiting_line_${WaitingLineType.Silver}_description_4`,
    `waiting_line_${WaitingLineType.Silver}_description_5`,
  ],
};

export const gold = {
  waitingLineType: WaitingLineType.Gold,
  title: `waiting_line_${WaitingLineType.Gold}_type`,
  descriptions: [
    `waiting_line_${WaitingLineType.Gold}_description_1`,
    `waiting_line_${WaitingLineType.Gold}_description_2`,
    `waiting_line_${WaitingLineType.Gold}_description_3`,
    `waiting_line_${WaitingLineType.Gold}_description_4`,
  ],
};

export const free = {
  waitingLineType: WaitingLineType.Free,
  title: `waiting_line_${WaitingLineType.Free}_type`,
  descriptions: [
    `waiting_line_${WaitingLineType.Free}_description_1`,
    `waiting_line_${WaitingLineType.Free}_description_2`,
    `waiting_line_${WaitingLineType.Free}_description_3`,
    `waiting_line_${WaitingLineType.Free}_description_4`,
    `waiting_line_${WaitingLineType.Free}_description_5`,
  ],
};

export const licensed = {
  waitingLineType: WaitingLineType.Licensed,
  title: `waiting_line_${WaitingLineType.Licensed}_type`,
  descriptions: [
    `waiting_line_${WaitingLineType.Licensed}_description_1`,
    `waiting_line_${WaitingLineType.Licensed}_description_2`,
  ],
};
